import React, { Component } from 'react';
import { Icon, Button, Segment, Header, Form } from 'semantic-ui-react';
import { documentTypes } from '../../utils/defaults';
class AddComment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            documentType: "",
            comment: ""
        };
    }


    handleChange = (e, evt) => {
        this.setState({
            [evt.name]: evt.value
        })

    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.handleSubmit(this.state);
    }

    showDropdownList = (show) => {
        if (show) {
            return (
                <Form.Field className="required">
                    <Form.Select label="Select an Document Reference" placeholder="Select" options={documentTypes.filter((d) => {
                        return this.props.docList.indexOf(d.value) >= 0 || (this.props.docRequestPending && this.props.docRequestPending.indexOf(d.value) >= 0);
                    })}
                        name="documentType" value={this.state.documentType} onChange={this.handleChange}>
                    </Form.Select>
                </Form.Field>
            )
        }
    }

    showShortNote = (show) => {
        if (this.props.shortCommentNote !== undefined) { return <p>{this.props.shortCommentNote}</p> }

    }

    render() {
        return (
            <Segment.Group>
                <Segment className="black center" inverted >
                    <Header as={"h4"}><Icon name="comment"></Icon>Add a Comment</Header>
                </Segment>
                <Segment>
                    <Form>
                        {this.showDropdownList(this.props.showDropdownList === undefined ? true : false)}
                        <Form.Field>
                            <label>Add a Comment</label>
                            {this.showShortNote(this.props.shortCommentNote)}
                            <Form.TextArea rows={2} placeholder="Comments.." name="comment" value={this.state.comment} onChange={this.handleChange} />
                        </Form.Field>
                    </Form>
                </Segment>
                <Segment secondary clearing>
                    <Button.Group className="right floated small buttons">
                        <Button onClick={this.props.closeComment}>Cancel</Button>
                        <Button.Or />
                        <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                    </Button.Group>
                </Segment>
            </Segment.Group>
        );
    }
}
export default AddComment;


// WEBPACK FOOTER //
// ./src/app/ui/alerts/AddComment.js